"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_BALANCE_ROUTES = exports.ACCOUNT_BALANCE_EVENTS = void 0;
/**
 * Account Balance WebSocket event constants
 * These are shared between backend and frontend
 */
exports.ACCOUNT_BALANCE_EVENTS = {
    BALANCE_UPDATED: 'balance_updated',
    ACCOUNT_UPGRADED: 'account_upgraded',
    SUBSCRIPTION_EXPIRED: 'subscription_expired',
    CREDITS_SPENT: 'credits_spent',
    CREDITS_ADDED: 'credits_added'
};
exports.ACCOUNT_BALANCE_ROUTES = {
    BALANCE_UPDATE: 'balance_update'
};
